import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    payrunList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: null,
    },
    payrunDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null,
    },
    payrunDtrList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
    },
    payrunOTList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
    },
    payrunNDList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
    },
    payslipDetails: {
      requesting: false,
      error: null,
      success: false,
      data: {
        ppr_employee_code: 'JUL-02501',
        ppr_employee_name: 'Rosa, Rolly',
        ppr_employee_hire_date: '2025-07-01',
        payroll: {
            pay_date_from: '2025-08-01',
            pay_date_to: '2025-08-15',
        },
        ppr_employee_designation: 'Juniro Full Stack Dev',
        ppr_employee_department: 'Operations',
        ppr_base_pay: 7500.00,
        ppr_gross_pay: 7500.00,
        ppr_withholding_tax: 0.00,
        ppr_net_pay: 7500.00,
      },
    },
  };

export const payrunSlice = createSlice({
  name: 'payrun',
  initialState,
  reducers: {
    getPayrunList: (state, action) => {
        state.payrunList.requesting = true;
        state.payrunList.error = null;
        state.payrunList.items = [];
        state.payrunList.success = false;
        state.payrunList.filters = action.payload;
    },
    getPayrunListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.payrunList.requesting = false;        
        state.payrunList.items = data;
        state.payrunList.success = true; 
        state.payrunList.pagination.current_page = current_page;
        state.payrunList.pagination.per_page = per_page;
        state.payrunList.pagination.total = total;
    },
    getPayrunListFail: (state, action) => {        
        state.payrunList.requesting = false;
        state.payrunList.error = action.payload;
    },
    getPayrunDetails: (state) => {
        state.payrunDetails.requesting = true;
        state.payrunDetails.error = null;
        state.payrunDetails.data = null;
        state.payrunDetails.success = false; 
    },
    getPayrunDetailsSuccess: (state, action) => {
        state.payrunDetails.requesting = false;
        state.payrunDetails.data = action.payload;
        state.payrunDetails.success = true; 
    },
    getPayrunDetailsFail: (state, action) => {        
        state.payrunDetails.requesting = false;
        state.payrunDetails.error = action.payload;
    },
    doPayrunCreate: (state) => {
        state.payrunDetails.requesting = true;
        state.payrunDetails.error = null;
        state.payrunDetails.data = null;
        state.payrunDetails.success = false; 
    },
    doPayrunUpdate: (state) => {
        state.payrunDetails.requesting = true;
        state.payrunDetails.error = null;
        state.payrunDetails.data = null;
        state.payrunDetails.success = false; 
    },
    doPayrunDelete: (state) => {
        state.payrunDetails.requesting = true;
        state.payrunDetails.error = null;
        state.payrunDetails.data = null;
        state.payrunDetails.success = false; 
    },
    getPayrunDtrList: (state) => {
        state.payrunDtrList.requesting = true;
        state.payrunDtrList.error = null;
        state.payrunDtrList.items = [];
        state.payrunDtrList.success = false;
    },
    getPayrunDtrListSuccess: (state, action) => {
        state.payrunDtrList.requesting = false;        
        state.payrunDtrList.items = action.payload;
        state.payrunDtrList.success = true; 
    },
    getPayrunDtrListFail: (state, action) => {        
        state.payrunDtrList.requesting = false;
        state.payrunDtrList.error = action.payload;
    },
    doPayrunDtrUpdate: (state) => {
        state.payrunDtrList.requesting = true;
        state.payrunDtrList.error = null;
        state.payrunDtrList.success = false;
    },
    doPayrunDtrUpdateSuccess: (state, action) => {
        state.payrunDtrList.requesting = false;        
        state.payrunDtrList.success = true; 
        const updatedItem = action.payload;
        state.payrunDtrList.items = state.payrunDtrList.items.map(item =>
            item.pdt_id === updatedItem.pdt_id ? { ...item, ...updatedItem } : item
        );
    },
    doPayrunDtrUpdateFail: (state, action) => {        
        state.payrunDtrList.requesting = false;
        state.payrunDtrList.error = action.payload;
    },
    getPayrunOTList: (state) => {
        state.payrunOTList.requesting = true;
        state.payrunOTList.error = null;
        state.payrunOTList.success = false;
    },
    getPayrunOTListSuccess: (state, action) => {
        state.payrunOTList.requesting = false;        
        state.payrunOTList.items = action.payload;
        state.payrunOTList.success = true; 
    },
    getPayrunOTListFail: (state, action) => {        
        state.payrunOTList.requesting = false;
        state.payrunOTList.error = action.payload;
    },
    doPayrunOTUpdate: (state) => {
        state.payrunOTList.requesting = true;
        state.payrunOTList.error = null;
        state.payrunOTList.success = false;
    },
    doPayrunOTUpdateSuccess: (state, action) => {
        state.payrunOTList.requesting = false;        
        //state.payrunOTList.items = action.payload;
        state.payrunOTList.success = true; 
    },
    doPayrunOTUpdateFail: (state, action) => {        
        state.payrunOTList.requesting = false;
        state.payrunOTList.error = action.payload;
    },
    getPayrunNDList: (state) => {
        state.payrunNDList.requesting = true;
        state.payrunNDList.error = null;
        state.payrunNDList.items = [];
        state.payrunNDList.success = false;
    },
    getPayrunNDListSuccess: (state, action) => {
        state.payrunNDList.requesting = false;        
        state.payrunNDList.items = action.payload;
        state.payrunNDList.success = true; 
    },
    getPayrunNDListFail: (state, action) => {        
        state.payrunNDList.requesting = false;
        state.payrunNDList.error = action.payload;
    },
    doPayrunNDUpdate: (state) => {
        state.payrunNDList.requesting = true;
        state.payrunNDList.error = null;
        state.payrunNDList.success = false;
    },
    doPayrunNDUpdateSuccess: (state, action) => {
        state.payrunNDList.requesting = false;        
        //state.payrunNDList.items = action.payload;
        state.payrunNDList.success = true; 
    },
    doPayrunNDUpdateFail: (state, action) => {        
        state.payrunNDList.requesting = false;
        state.payrunNDList.error = action.payload;
    },
    doPayrollPayrunSync: (state) => {
        state.payrunList.requesting = true;
        state.payrunList.error = null;
        state.payrunList.items = [];
        state.payrunList.success = false;
    },
    getPayslipDetails: (state) => {
        state.payslipDetails.requesting = true;
        state.payslipDetails.error = null;
        state.payslipDetails.data = null;
        state.payslipDetails.success = false; 
    },
    getPayslipDetailsSuccess: (state, action) => {
        state.payslipDetails.requesting = false;
        state.payslipDetails.data = action.payload;
        state.payslipDetails.success = true;
        state.payslipDetails.error = null; 
    },
    getPayslipDetailsFail: (state, action) => {        
        state.payslipDetails.requesting = false;
        state.payslipDetails.error = action.payload;
    },
    sendPayslip: (state) => {
        state.payslipDetails.requesting = true;
        state.payslipDetails.error = null;
        state.payslipDetails.success = false; 
    },
    sendPayslipSuccess: (state, action) => {
        state.payslipDetails.requesting = false;
        state.payslipDetails.success = true;
        state.payslipDetails.error = null; 
    },
    sendPayslipFail: (state, action) => {        
        state.payslipDetails.requesting = false;
        state.payslipDetails.error = action.payload;
    },
  },
})

export const { 
    getPayrunList, getPayrunListSuccess, getPayrunListFail,
    getPayrunDetails, getPayrunDetailsSuccess, getPayrunDetailsFail,
    doPayrunCreate, doPayrunUpdate, doPayrunDelete,
    getPayrunDtrList, getPayrunDtrListSuccess, getPayrunDtrListFail,
    doPayrunDtrUpdate, doPayrunDtrUpdateSuccess, doPayrunDtrUpdateFail,
    getPayrunOTList, getPayrunOTListSuccess, getPayrunOTListFail,
    doPayrunOTUpdate, doPayrunOTUpdateSuccess, doPayrunOTUpdateFail,
    getPayrunNDList, getPayrunNDListSuccess, getPayrunNDListFail,
    doPayrunNDUpdate, doPayrunNDUpdateSuccess, doPayrunNDUpdateFail,
    doPayrollPayrunSync,
    getPayslipDetails, getPayslipDetailsSuccess, getPayslipDetailsFail,
    sendPayslip, sendPayslipSuccess, sendPayslipFail,
} = payrunSlice.actions

export default payrunSlice.reducer